module.exports = __webpack_public_path__ + "img/align-top.32970101.svg";